<template>
  <div class="reviewed-thesis wrap-content">
    <!-- <Card style="border:0;" dis-hover>
      <p slot="title">学生信息</p>
      <Row class="box">
        <Col span="8">所属院系：{{stuInfo.academyName}}</Col>
        <Col span="8">一级学科：{{stuInfo.firstSubjectName}}</Col>
        <Col span="8">二级学科：{{stuInfo.secondSubjectName}}</Col>
        <Col span="8">论文题目：{{stuInfo.titleCn}}</Col>
        <Col span="8">学号：{{stuInfo.schoolNo}}</Col>
        <Col span="8">姓名：{{stuInfo.authorName}}</Col>
      </Row>
    </Card> -->
    <Card class="g-mt box" style="border:0;" dis-hover>
      <p slot="title">评阅信息</p>
      <Row>
        <Col span="8">评阅类型：隐名评阅</Col>
        <Col span="8">一级学科：{{stuInfo.firstSubjectName}}</Col>
        <Col span="8">二级学科：{{stuInfo.secondSubjectName}}</Col>
        <Col span="8">攻读类别：{{stuInfo.degreeType}}</Col>
        <Col span="8">学习方式：{{stuInfo.learningStyleMc}}</Col>
        <Col span="8">论文设计的研究方向：{{stuInfo.researchAera}}</Col>
        <Col span="8">中文题目：{{stuInfo.titleCn}}</Col>
        <Col span="16">英文题目：{{stuInfo.titleEn}}</Col>
        <div v-if="schoolAuditPlanConfig.partJudgeOpen==1">
          <Col span="16">参考评阅要素：</Col>
          <Row>
            <Col span="12"  style="text-align: center">
              <div class="div-table-border">
                <table class="table-fxpj">
                  <tbody>
                  <tr>
                    <td width="20%">评价指标</td>
                    <td width="10%">{{schoolAuditPlanConfig.partJudgeMode === '1' ? '分数' : '比例'}}</td>
                    <td width="60%">评价要素</td>
                    <td width="10%">评阅得分</td>
                  </tr>
                  <tr v-if="expReviewInfo.partScoreOne">
                    <td>
                      <span>{{schoolAuditPlanConfig.partNameOne}}</span>
                    </td>
                    <td>
                      <span>{{schoolAuditPlanConfig.partScoresOne}}</span>
                    </td>
                    <td>
                      <div v-for="(ele, index) in formDynamic.itemsOne" :key="index">
                        <p>{{ele.item}}</p>
                      </div>
                    </td>
                    <td>
                      <span>{{expReviewInfo.partScoreOne}}</span>
                    </td>
                  </tr>
                  <tr v-if="expReviewInfo.partScoreTwo">
                    <td>
                      <span>{{schoolAuditPlanConfig.partNameTwo}}</span>
                    </td>
                    <td>
                      <span>{{schoolAuditPlanConfig.partScoresTwo}}</span>
                    </td>
                    <td>
                      <div v-for="(ele, index) in formDynamic.itemsTwo" :key="index">
                        <p>{{ele.item}}</p>
                      </div>
                    </td>
                    <td>
                      <span>{{expReviewInfo.partScoreTwo}}</span>
                    </td>
                  </tr>
                  <tr v-if="expReviewInfo.partScoreThree">
                    <td>
                      <span>{{schoolAuditPlanConfig.partNameThree}}</span>
                    </td>
                    <td>
                      <span>{{schoolAuditPlanConfig.partScoresThree}}</span>
                    </td>
                    <td>
                      <div v-for="(ele, index) in formDynamic.itemsThree" :key="index">
                        <p>{{ele.item}}</p>
                      </div>
                    </td>
                    <td>
                      <span>{{expReviewInfo.partScoreThree}}</span>
                    </td>
                  </tr>
                  <tr v-if="expReviewInfo.partScoreFour">
                    <td>
                      <span>{{schoolAuditPlanConfig.partNameFour}}</span>
                    </td>
                    <td>
                      <span>{{schoolAuditPlanConfig.partScoresFour}}</span>
                    </td>
                    <td>
                      <div v-for="(ele, index) in formDynamic.itemsFour" :key="index">
                        <p>{{ele.item}}</p>
                      </div>
                    </td>
                    <td>
                      <span>{{expReviewInfo.partScoreFour}}</span>
                    </td>
                  </tr>
                  <tr v-if="expReviewInfo.partScoreFive">
                    <td>
                      <span>{{schoolAuditPlanConfig.partNameFive}}</span>
                    </td>
                    <td>
                      <span>{{schoolAuditPlanConfig.partScoresFive}}</span>
                    </td>
                    <td>
                      <div v-for="(ele, index) in formDynamic.itemsFive" :key="index">
                        <p>{{ele.item}}</p>
                      </div>
                    </td>
                    <td>
                      <span>{{expReviewInfo.partScoreFive}}</span>
                    </td>
                  </tr>
                  <tr v-if="expReviewInfo.partScoreSix">
                    <td>
                      <span>{{schoolAuditPlanConfig.partNameSix}}</span>
                    </td>
                    <td>
                      <span>{{schoolAuditPlanConfig.partScoresSix}}</span>
                    </td>
                    <td>
                      <div v-for="(ele, index) in formDynamic.itemsSix" :key="index">
                        <p>{{ele.item}}</p>
                      </div>
                    </td>
                    <td>
                      <span>{{expReviewInfo.partScoreSix}}</span>
                    </td>
                  </tr>
                  <tr v-if="expReviewInfo.partScoreSeven">
                    <td>
                      <span>{{schoolAuditPlanConfig.partNameSeven}}</span>
                    </td>
                    <td>
                      <span>{{schoolAuditPlanConfig.partScoresSeven}}</span>
                    </td>
                    <td>
                      <div v-for="(ele, index) in formDynamic.itemsSeven" :key="index">
                        <p>{{ele.item}}</p>
                      </div>
                    </td>
                    <td>
                      <span>{{expReviewInfo.partScoreSeven}}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <div v-if="schoolAuditPlanConfig.innovationLevel">
          <Col span="24" v-if="expReviewInfo.innovationOne">
            <span>创新点1：</span>
            <Input type="textarea" v-model="expReviewInfo.innovationOne" readonly/>
          </Col>
          <Col span="24" v-if="expReviewInfo.innovationTwo">
            <span>创新点2：</span>
            <Input type="textarea" v-model="expReviewInfo.innovationTwo" readonly/>
          </Col>
          <Col span="24" v-if="expReviewInfo.innovationThree">
            <span>创新点3：</span>
            <Input type="textarea" v-model="expReviewInfo.innovationThree" readonly/>
          </Col>
          <Col span="24" v-if="expReviewInfo.innovationFour">
            <span>创新点4：</span>
            <Input type="textarea" v-model="expReviewInfo.innovationFour" readonly/>
          </Col>
          <Col span="24" v-if="expReviewInfo.innovationFive">
            <span>创新点5：</span>
            <Input type="textarea" v-model="expReviewInfo.innovationFive" readonly/>
          </Col>
        </div>
        <Col span="24">
          <span>评阅意见（请对论文的学术水平、创新性做出简要评述，包括选题意义、论文创新点、学科知识的掌握、写作规范性和逻辑性等）：</span>
          <Input type="textarea" v-model="expReviewInfo.reviewOpinion" readonly/>
        </Col>
        <Col span="24">
          <span>不足之处及修改意见（明确指出论文中存在的问题和不足之处，并请提出修改意见）：</span>
        </Col>
        <Col span="24">
          <Input type="textarea" v-model="expReviewInfo.deficiencies" readonly/>
        </Col>
        <Col span="24">
          <span>总体评价：</span>
          <Input v-model="expReviewInfo.score" style="width: 200px" readonly v-if="expReviewInfo.score"/>
          <Input v-model="expReviewInfo.evaluation" style="width: 200px" readonly v-if="expReviewInfo.score"/>
          <Input v-model="expReviewInfo.evaluation" readonly v-else/>
        </Col>
        <Col span="24">
          <span>答辩决定：</span>
          <Input v-model="expReviewInfo.reviewResult" readonly/>
        </Col>
        <Col span="24" v-if="schoolAuditPlanConfig.familiarOpen === '1'">
          <span>专家对此领域的熟悉程度：</span>
          <Input v-model="expReviewInfo.familiarLevel" readonly/>
        </Col>
        <Col span="24" v-if="expReviewInfo.description">
          <span>推荐理由：</span>
          <Input v-model="expReviewInfo.description" readonly/>
        </Col>
        <Col span="24" v-if="expReviewInfo.excellentLevel">
          <span>优秀论文分档：</span>
          <Input v-model="expReviewInfo.excellentLevel" readonly/>
        </Col>
      </Row>
    </Card>
  </div>
</template>
<script>
export default {
  name: 'reviewedThesis',
  props: {
    queryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      id: '',
      stuInfo: {},
      expReviewInfo: {},
      schoolAuditPlanConfig: {},
      formDynamic: {
        itemsOne: [
          {
            value: '',
            index: 1
          }
        ],
        itemsTwo: [
          {
            value: '',
            index: 1
          }
        ],
        itemsThree: [
          {
            value: '',
            index: 1
          }
        ],
        itemsFour: [
          {
            value: '',
            index: 1
          }
        ],
        itemsFive: [
          {
            value: '',
            index: 1
          }
        ],
        itemsSix: [
          {
            value: '',
            index: 1
          }
        ],
        itemsSeven: [
          {
            value: '',
            index: 1
          }
        ]
      }
    }
  },
  watch: {
    '$route' (to, from) {
      // 路由发生变化页面刷新
      this.$router.go(0);
    }
  },
  created () {
    this.id = this.$route.query['id'];
    if (this.id) {
      this.fetchDetail()
    }
  },
  methods: {
    fetchDetail () {
      this.fetch('/exp/expReviewInfo/queryReviewInfoByExp/' + this.id).then(res => {
        this.stuInfo = res.data.paperBaseInfo
        this.expReviewInfo = res.data.expReview
        this.schoolAuditPlanConfig = res.data.schoolAuditPlanConfigDTO
        this.formDynamic.itemsOne = this.schoolAuditPlanConfig.partDetailOne.split('|').map((ele, index) => {
          return {
            item: ele,
            index: index
          }
        })
        this.formDynamic.itemsTwo = this.schoolAuditPlanConfig.partDetailTwo.split('|').map((ele, index) => {
          return {
            item: ele,
            index: index
          }
        })
        this.formDynamic.itemsThree = this.schoolAuditPlanConfig.partDetailThree.split('|').map((ele, index) => {
          return {
            item: ele,
            index: index
          }
        })
        this.formDynamic.itemsFour = this.schoolAuditPlanConfig.partDetailFour.split('|').map((ele, index) => {
          return {
            item: ele,
            index: index
          }
        })
        this.formDynamic.itemsFive = this.schoolAuditPlanConfig.partDetailFive.split('|').map((ele, index) => {
          return {
            item: ele,
            index: index
          }
        })
        this.formDynamic.itemsSix = this.schoolAuditPlanConfig.partDetailSix.split('|').map((ele, index) => {
          return {
            item: ele,
            index: index
          }
        })
        this.formDynamic.itemsSeven = this.schoolAuditPlanConfig.partDetailSeven.split('|').map((ele, index) => {
          return {
            item: ele,
            index: index
          }
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.reviewed-thesis {
  .box .kh-col {
    margin-bottom: 10px;
  }
  .div-table-border{
    border: @border-width-base @border-style-base @border-color-base;
    border-radius: @border-radius-small;
  }
  /deep/.table-fxpj{
    border-spacing: 0;
    width: 100%;
    tr {
      td {
        border-bottom: @border-width-base @border-style-base @border-color-base;
        text-align: left;
        padding: 8px;
        border-left: @border-width-base @border-style-base @border-color-base;
        input {
          line-height: 33px;
          height: 33px;
          border: 0 none;
          margin-left: -8px;
          text-indent: 8px;
          width: calc(100% + 6px);
          &:focus {
            border-color: #62bfe1;
            outline: 0;
            box-shadow: 0 0 0 2px rgba(@base-color, .2);
          }
        }
        textarea {
          line-height: 1.15;
          height: 40px;
          border: 0 none;
          margin-left: -8px;
          padding-left: 8px;
          padding-top: 4px;
          width: calc(100% + 6px);
          float: left;
          &:focus {
            border-color: #62bfe1;
            outline: 0;
            box-shadow: 0 0 0 2px rgba(@base-color, .2);
          }
        }
      }
      &:last-child td{
        border-bottom: 0 none;
      }
    }
  }
  .add-circle {
    font-size: 20px;
    color: #1890ff;
    cursor: pointer;
  }
  .del-circle {
    font-size: 20px;
    color: #ed4014;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/reviewedThesis.vue